var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DotMenu"},[(_vm.isBusy)?_c('spinner'):_c('button',{staticClass:"Button Button--dot",class:{'is-open': _vm.isOpen},on:{"click":_vm.toggle}},[_c('i',{staticClass:"Icon Icon--only"},[_vm._v("more_vert")])]),(_vm.isOpen)?_c('ul',{staticClass:"DotMenu-dropdown"},[_vm._t("default")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }